import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';

// Column
import { GallaryColumns } from '../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, ApplicationStatusOptions, ActiveInactiveOptions } from '../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails, postAllData } from '../../service/ProductService';

// Api
import { ADD_GALLERY, DELETE_GALLERY, GALLERY_STATUS, GET_GALLERY, NOTICE_STATUS } from '../../config/ApiConstant';
import { addGallryValidate, addUpdateGallry } from '../../config/Validate';
import { FrontWebsiteTabs } from './FrontWebsiteTab';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';

export const Gallary = () => {
    document.title = 'Gallary | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    interface ImageItem {
        file: File;
        preview: string;
    }
    const [GallaryImages, setGallaryImages] = useState<ImageItem[]>([]);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [gallaryList, setGallaryList] = useState<any>([]);
    const [editId, setEditId] = useState<any>(null);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [updateModal, setUpdateModal] = useState<boolean>(false);
    const [addModal, setAddModal] = useState<boolean>(false);
    const [openApproveModal, setOpenApproveModal] = useState<boolean>(false);
    const [approveId, setApproveId] = useState<any>(null);
    const [approveVal, setApproveVal] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [approveLoading, setApproveLoading] = useState<boolean>(false);
    const [noticeDetails, setNoticeDetails] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });

    // use effect method
    useEffect(() => {
        getAllGallaryData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get college list api call
    const getAllGallaryData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_GALLERY);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setGallaryList([]);
                } else {
                    setGallaryList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setGallaryList([]);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(false);
                setGallaryList([]);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    const handleImageChange = (e: any) => {
        const files = Array.from(e.target.files);

        const newImages = files.map((file: any) => ({
            file,
            preview: URL.createObjectURL(file)
        }));

        setGallaryImages((prevImages: any) => [...prevImages, ...newImages]);
    };


    const handleRemoveImage = (index: number) => {
        setGallaryImages((prevImages) => {
            const updated = [...prevImages];
            URL.revokeObjectURL(updated[index].preview);
            updated.splice(index, 1);
            return updated;
        });
    };
    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
        getAllGallaryData();
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add Gallary" icon="pi pi-plus" className="p-button mr-2" onClick={() => openAddModal()} />
            </>
        );
    };

    //clear button
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>
            </>
        );
    };

    // Template for action body
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions">
                    <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="p-button-rounded mr-2" onClick={() => linkOpen(rowData?.image)} />
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData.id)} />
                </div>
            </>
        );
    };

    //status Template
    const statusTemplate = (rowData: any) => {
        return (
            <>
                <InputSwitch checked={rowData?.status === 1 ? true : false} onChange={(e) => openApprove(e.value, rowData.id)} defaultChecked={rowData.status === 1 ? true : false} />
            </>
        );
    };

    //Open Link in new tab
    const linkOpen = (file: any) => {
        window.open(file, '_blank');
    };

    // Open add modal
    const openAddModal = () => {
        setAddModal(true);
    };

    //close Add modal
    const closeAddModal = () => {
        setAddModal(false);
        setGallaryImages([]);
        setErrors({});
        setSubmitLoading(false);
    };

    // Close add update modal
    const closeupdateModal = () => {
        setNoticeDetails({});
        setErrors({});
        setEditId(null);
        setSubmitLoading(false);
        setUpdateModal(false);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData?.id);

        const fileName = rowData.image.split('/').pop();
        const fileType = `${fileName.split('.').pop()}`;
        // Create the desired object
        const FileObject = {
            url: rowData.image,
            name: fileName,
            type: fileType
        };
        setNoticeDetails({
            notice_title: rowData?.notice_title,
            image: FileObject
        });
        setUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setSubmitLoading(false);
        setDeleteModal(false);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'image') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || '';
        }
        setNoticeDetails({ ...noticeDetails, [name]: val });
    };

    // On submit add update college
    const onSubmitAddUpdateGallary = async () => {
        try {
            let isImageError: any;
            if (!window.cn(editId)) {
                const { errors, isError } = addUpdateGallry(noticeDetails);
                setErrors(errors);
                isImageError = isError;
            } else {
                const { errors, isError } = addGallryValidate(GallaryImages);
                setErrors(errors);
                isImageError = isError;
            }

            //Check Error if no errors then call API
            if (!isImageError) {
                setSubmitLoading(true);

                //Request object
                let formData: any = new FormData();

                // Check editing is performed or not

                if (editId !== null) {
                    formData.append('id', editId);

                    if (noticeDetails?.image && noticeDetails?.image?.name && !noticeDetails?.image?.url) {
                        formData.append('image', noticeDetails?.image);
                    }
                } else {
                    // Check for image if uploaded or not
                    //Add images in formdata
                    GallaryImages.map((item) => {
                        formData.append('image[]', item?.file);
                    });
                }

                //apicall
                const response = await postAllData(ADD_GALLERY, formData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    closeupdateModal();
                    closeAddModal();
                    setTimeout(() => {
                        getAllGallaryData();
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                const backendErrors = error.response.data.errors;

                if (backendErrors) {
                    // Map backend errors to your state
                    const formattedErrors: any = {};

                    Object.keys(backendErrors).forEach((key) => {
                        formattedErrors[key] = backendErrors[key].join(' '); // Convert array messages into a single string
                    });
                    setErrors(formattedErrors);
                    setSubmitLoading(false);

                    toast.current?.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'Please fix the errors and try again.'
                    });
                } else {
                    //Spinner False and Set Toast

                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
                }
            }
        }
    };

    // Delete college api call
    const deleteCollegeApiCall = async () => {
        try {
            setSubmitLoading(true);
            // Delete api call
            const response = await deleteDataWithMultipleParameters(DELETE_GALLERY + '?id=' + deleteId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setSubmitLoading(false);
                setDeleteModal(false);
                setDeleteId(null);
                getAllGallaryData();
                setPageLoad(true);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setSubmitLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    //delete selected file
    const onFileDelete = (name: string) => {
        setNoticeDetails({ ...noticeDetails, [name]: '' });
    };

    //Open Approve Modal
    const openApprove = (val: any, id: any) => {
        setOpenApproveModal(true);
        setApproveId(id);

        if (val === true) {
            setApproveVal(1);
        } else {
            setApproveVal(0);
        }
    };
    //close Approve Modal
    const closeApproveModal = () => {
        setOpenApproveModal(false);
        setApproveId(null);
        setApproveVal(null);
    };

    //status chnage api
    const approveStatusChange = async () => {
        try {
            setApproveLoading(true);

            const requestData = {
                id: approveId,
                status: approveVal
            };

            const response = await postAllData(GALLERY_STATUS, requestData);
            if (response) {
                setApproveLoading(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                closeApproveModal();
                getAllGallaryData();
            }
        } catch (error: any) {
            if (error.response) {
                setApproveLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
            }
        }
    };

    const gallaryTemplate = (rowData: any) => {
        return (
            <>
                <img className="banner-image gallary-img img-fluid" src={!window.cn(rowData?.image) ? rowData?.image : ''} alt="No Image" />
            </>
        );
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={ActiveInactiveOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    return (
        <>
           <FrontWebsiteTabs mainTabLabel="Gallery" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={gallaryList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={gallaryList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive "
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Colleges Found"
                                    removableSort
                                >
                                    {GallaryColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'image') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={gallaryTemplate} />;
                                        } else if (col.field === 'status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '3rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {GallaryColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* \Add Image Dialog */}
            <Dialog
                visible={addModal}
                className="p-fluid"
                style={{ width: '500px' }}
                header={'Add Gallary'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateGallary()} loading={submitLoading} />
                    </>
                }
                onHide={closeAddModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">Gallery File </label>

                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Image</span>
                            <input type="file" id="fileInput" multiple accept="image/png, image/jpeg , image/jpg" onChange={handleImageChange} className="file-input" />
                        </div>
                        <small className="p-invalid-txt">{errors['gallary_image']}</small>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                        {GallaryImages.map((img: any, index: any) => (
                            <div key={index} style={{ position: 'relative' }}>
                                <img src={img.preview} alt="preview" className="img-fluid preview-banner" style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
                                <button
                                    onClick={() => handleRemoveImage(index)}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        background: 'red',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            {/* Edit Image Dialog */}
            <Dialog
                visible={updateModal}
                className="p-fluid"
                style={{ width: '500px' }}
                header={'Edit gallary'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeupdateModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateGallary()} loading={submitLoading} />
                    </>
                }
                onHide={closeupdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">Gallery File </label>

                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Image</span>
                            <input type="file" id="fileInput" accept="image/png, image/jpeg , image/jpg" onChange={(e) => onInputChange(e, 'image')} className="file-input" />
                        </div>
                        <small className="p-invalid-txt">{errors['image']}</small>

                        {window.cn(editId) && !window.cn(noticeDetails?.image) && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(noticeDetails?.image)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {noticeDetails?.image.name}
                                    </a>
                                    <span className="file-details">
                                        {noticeDetails?.image.type} &nbsp;♦&nbsp; {(noticeDetails?.image.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        )}

                        {!window.cn(editId) && !window.cn(noticeDetails)
                            ? (!window.cn(noticeDetails?.image) || noticeDetails?.image?.name) && (
                                  <>
                                      <div className="file-preview">
                                          <div className="file-info">
                                              <a href={!window.cn(noticeDetails?.image) ? noticeDetails?.image?.url : URL.createObjectURL(noticeDetails?.image?.url)} target="_blank" rel="noopener noreferrer" className="file-name">
                                                  {noticeDetails?.image?.name}
                                              </a>
                                              <span className="file-details">
                                                  {noticeDetails?.image.type} &nbsp;&nbsp; {!window.cn(noticeDetails?.image.size) && (noticeDetails?.image.size / 1024).toFixed(2) + ' ' + 'KB'}
                                              </span>
                                          </div>
                                      </div>
                                  </>
                              )
                            : ''}
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Gallary"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteCollegeApiCall} loading={submitLoading} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Gallary Image, This will be deleted permanently.</span>
                </div>
            </Dialog>

            {/* Status Change Dialog */}
            <Dialog
                visible={openApproveModal}
                style={{ width: '450px' }}
                header="Gallary"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeApproveModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => approveStatusChange()} loading={approveLoading} />
                    </>
                }
                onHide={closeApproveModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <span className="dialog-note">Note: It will Active or Inactive the Gallary.</span>
                </div>
            </Dialog>
        </>
    );
};
